import './bootstrap';
import { registerLivewireAnimeSortable } from './livewire-anime-sortable';
import moment from 'moment'
window.moment = moment

import intersect from '@alpinejs/intersect';
import './bootstrap';
// import Bugsnag from '@bugsnag/js';
import '@fortawesome/fontawesome-free/css/all.css';

// Import Leaflet for admin maps
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in Leaflet with Webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Make Leaflet available globally
window.L = L;

function bootLivewireAnimeSortable() {
    if (typeof window.Livewire !== 'undefined' && window.Livewire.directive) {
        registerLivewireAnimeSortable(window.Livewire);
    }
}

document.addEventListener('livewire:init', bootLivewireAnimeSortable);
bootLivewireAnimeSortable();

document.addEventListener('alpine:init', () => {
    window.Alpine.data('themeToggle', (gates = {}) => ({
        canUseSepiaTheme: Boolean(gates.canUseSepiaTheme),
        canUseStrawberryTheme: Boolean(gates.canUseStrawberryTheme),
        resolved: document.documentElement.getAttribute('data-theme') || 'light',
        selected: localStorage.getItem('theme') || 'light',
        apply(theme) {
            if (theme === 'sepia' && !this.canUseSepiaTheme) {
                return;
            }
            if (theme === 'strawberry' && !this.canUseStrawberryTheme) {
                return;
            }
            const r = theme === 'system'
                ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
                : theme;
            localStorage.setItem('theme', theme);
            document.documentElement.setAttribute('data-theme', r);
            const m = document.querySelector('meta[name="theme-color"]');
            if (m) {
                const metaColors = { dark: '#111827', sepia: '#f5f0e8', pink: '#fdf2f4', strawberry: '#fdf2f4', light: '#f3f4f6' };
                m.setAttribute('content', metaColors[r] || '#f3f4f6');
            }
            this.resolved = r;
            this.selected = theme;
            this.$wire.setTheme(theme);
        },
    }));
});
import.meta.glob([
    '../images/**',
    '../fonts/**',
]);
// Bugsnag.start('02c2e6cd83560482254a5eb604f86008')

const appEnv = import.meta.env.APP_ENV;

// Bugsnag.start({
//     apiKey: '02c2e6cd83560482254a5eb604f86008',
//     enabledReleaseStages: [ 'production', 'beta'],
//     releaseStage: appEnv
// })
